import { useCallback, useState } from "react";
import type { AmpLibraryFileFragment } from "src/graphql";
import { DownloadFileDialog } from "src/pages/projects/library/files/download-file-dialog";
import {
  downloadFile,
  getFileDownload,
  hasDownloadFormats,
} from "src/pages/projects/library/files/file-download";

/** Downloads a stored file directly and opens the format choice for everything else; render `dialog` beside the trigger. */
export function useFileDownload() {
  const [file, setFile] = useState<AmpLibraryFileFragment>();
  const close = useCallback(() => setFile(undefined), []);
  const requestDownload = (target: AmpLibraryFileFragment) => {
    if (hasDownloadFormats(target)) {
      setFile(target);
      return;
    }
    const download = getFileDownload(target);
    if (download) downloadFile(download);
  };
  const dialog = file ? (
    <DownloadFileDialog file={file} onClose={close} />
  ) : null;
  return { requestDownload, dialog };
}
